import React, { useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function KitContents() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const tomos = [{
    title: 'TOMO 1 — GEOGRAFÍA RURAL PRODUCTIVA I',
    icon: '🌾',
    items: ['Uso del suelo explicado de forma clara y aplicable', 'Regiones productivas argentinas con ejemplos reales', 'Actividades agropecuarias desarrolladas paso a paso', 'Casos reales del campo para trabajar en clase'],
    highlight: 'Incluye actividades listas, análisis de mapas y ejercicios prácticos',
    subHighlight: 'Para que el alumno entienda la geografía desde lo que vive'
  }, {
    title: 'TOMO 2 — GEOGRAFÍA RURAL PRODUCTIVA II',
    icon: '🚜',
    items: ['Cadenas productivas explicadas de forma simple', 'Producción agrícola y ganadera con ejemplos concretos', 'Economía rural aplicada al territorio', 'Actividades para analizar cómo se produce en Argentina'],
    highlight: 'Incluye trabajos prácticos, análisis de casos y evaluaciones listas',
    subHighlight: 'Para enseñar el sistema productivo real, no teoría vacía'
  }, {
    title: 'TOMO 3 — GEOGRAFÍA AMBIENTAL RURAL I',
    icon: '🌱',
    items: ['Ecosistemas rurales explicados con ejemplos reales', 'Recursos naturales y su uso en el campo', 'Relación entre sociedad y ambiente', 'Actividades para analizar el entorno del alumno'],
    highlight: 'Incluye ejercicios de observación y reflexión',
    subHighlight: 'Para conectar el contenido con su realidad'
  }, {
    title: 'TOMO 4 — GEOGRAFÍA AMBIENTAL RURAL II',
    icon: '🌎',
    items: ['Problemáticas ambientales actuales (reales, no genéricas)', 'Sustentabilidad aplicada al campo', 'Cambio climático en zonas rurales', 'Debates y análisis de casos argentinos'],
    highlight: 'Incluye actividades, preguntas guía y evaluaciones',
    subHighlight: 'Para enseñar lo que realmente está pasando hoy'
  }, {
    title: 'TOMO 5 — GEOGRAFÍA AGRARIA I',
    icon: '🧭',
    items: ['Tenencia de la tierra explicada de forma simple', 'Estructura agraria argentina', 'Organización del espacio rural', 'Actividades para entender cómo funciona el campo'],
    highlight: 'Incluye ejercicios, análisis y trabajos prácticos',
    subHighlight: 'Para que el alumno entienda el sistema rural completo'
  }, {
    title: 'TOMO 6 — GEOGRAFÍA AGRARIA II',
    icon: '📊',
    items: ['Tecnología agropecuaria actual', 'Modernización del campo', 'Globalización y producción', 'Nuevos modelos productivos'],
    highlight: 'Incluye análisis, actividades y evaluación completa',
    subHighlight: 'Para enseñar el presente y el futuro del agro'
  }];
  return <section className="bg-[#0E1F19] py-4 md:py-6 px-3 border-b border-[#1F3D2B]" data-id="element-103">
      <div className="max-w-2xl mx-auto" data-id="element-104">
        <h2 className="text-xl md:text-2xl font-black text-[#74C69D] text-center mb-3 uppercase tracking-tight" data-id="element-105">
          📖 QUÉ RECIBÍS
        </h2>

        <div className="space-y-1.5 mb-4" data-id="element-106">
          {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-[#102A1F] border border-[#1F3D2B] rounded-lg overflow-hidden" data-id="element-107">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-2.5 text-left hover:bg-[#1A3D2D] transition-colors" data-id="element-108">
                  <span className="font-black text-[#D4A843] text-xs md:text-sm flex items-center gap-2 uppercase" data-id="element-109">
                    <span className="text-base" data-id="element-110">{tomo.icon}</span> {tomo.title}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} data-id="element-111">
                    <ChevronDown className="w-4 h-4 text-[#D4A843]" data-id="element-112" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-113">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-114">
                      <div className="px-3 pb-3 border-t border-[#1F3D2B] bg-[#071A14]" data-id="element-115">
                        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 mt-2 mb-2" data-id="element-116">
                          {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-1.5 text-white font-medium text-[10px] md:text-xs" data-id="element-117">
                              <Check className="w-3.5 h-3.5 text-[#74C69D] flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-118" />
                              <span data-id="element-119">{item}</span>
                            </li>)}
                        </ul>
                        <div className="bg-[#102A1F] border border-[#D4A843]/30 rounded p-2 text-center mt-2" data-id="element-120">
                          <p className="text-[#D4A843] font-black text-[10px] md:text-xs" data-id="element-121">
                            👉 {tomo.highlight}
                          </p>
                          <p className="text-[#BFC9C5] font-bold text-[9px] md:text-[10px] mt-0.5" data-id="element-122">
                            👉 {tomo.subHighlight}
                          </p>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="text-center bg-[#102A1F] border border-[#D4A843] rounded-xl p-3 shadow-lg" data-id="element-123">
          <p className="text-sm md:text-base font-black text-white mb-1 uppercase" data-id="element-124">
            👉 Todo explicado paso a paso, listo para aplicar
          </p>
          <p className="text-xs font-black text-[#74C69D]" data-id="element-125">
            👉 Entrás a cada clase con todo resuelto
          </p>
        </div>
      </div>
    </section>;
}